let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("2fGE9")).then(() => parcelRequire('1yKGc'));